import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import ChatWidget from '@/components/ChatWidget';
import SmoothScroll from '@/components/SmoothScroll';
import { ContentProvider } from '@/context/ContentContext';

import Home from '@/pages/Home';
import About from '@/pages/About';
import ServicesIndex from '@/pages/ServicesIndex';
import ServiceDetail from '@/pages/ServiceDetail';
import Fleet from '@/pages/Fleet';
import ServiceAreas from '@/pages/ServiceAreas';
import Testimonials from '@/pages/Testimonials';
import FAQ from '@/pages/FAQ';
import Careers from '@/pages/Careers';
import Contact from '@/pages/Contact';
import Booking from '@/pages/Booking';
import Quote from '@/pages/Quote';
import Referral from '@/pages/Referral';
import MyBookings from '@/pages/MyBookings';
import { Privacy, Terms } from '@/pages/Legal';

import AdminLogin from '@/pages/admin/AdminLogin';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminList from '@/pages/admin/AdminList';
import AdminCMS from '@/pages/admin/AdminCMS';
import AdminTestimonials from '@/pages/admin/AdminTestimonials';
import AdminFleet from '@/pages/admin/AdminFleet';
import AdminDrivers from '@/pages/admin/AdminDrivers';
import AdminSchedule from '@/pages/admin/AdminSchedule';
import DriverLogin from '@/pages/driver/DriverLogin';
import DriverPortal from '@/pages/driver/DriverPortal';

import '@/App.css';

function PublicShell({ children }) {
  const location = useLocation();
  const isPortal = location.pathname.startsWith('/admin') || location.pathname.startsWith('/driver');
  if (isPortal) return children;
  return (
    <>
      <NavBar />
      {children}
      <Footer />
      <ChatWidget />
    </>
  );
}

function AppRoutes() {
  return (
    <PublicShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesIndex />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/service-areas" element={<ServiceAreas />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Booking />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/refer" element={<Referral />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/driver/login" element={<DriverLogin />} />
        <Route path="/driver" element={<DriverPortal />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="enquiries" element={<AdminList kind="enquiries" />} />
          <Route path="bookings" element={<AdminList kind="bookings" />} />
          <Route path="quotes" element={<AdminList kind="quotes" />} />
          <Route path="referrals" element={<AdminList kind="referrals" />} />
          <Route path="cms" element={<AdminCMS />} />
          <Route path="fleet" element={<AdminFleet />} />
          <Route path="drivers" element={<AdminDrivers />} />
          <Route path="schedule" element={<AdminSchedule />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
        </Route>

        <Route path="*" element={<Home />} />
      </Routes>
    </PublicShell>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <SmoothScroll />
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}
